/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadSlot } from './UploadSlot';
import {
    UploadSlotFromJSON,
    UploadSlotFromJSONTyped,
    UploadSlotToJSON,
    UploadSlotToJSONTyped,
} from './UploadSlot';

/**
 * 
 * @export
 * @interface UploadBatchCreateResponse
 */
export interface UploadBatchCreateResponse {
    /**
     * 
     */
    batchId: string;
    /**
     * 
     */
    uploads: Array<UploadSlot>;
}

/**
 * Check if a given object implements the UploadBatchCreateResponse interface.
 */
export function instanceOfUploadBatchCreateResponse(value: object): value is UploadBatchCreateResponse {
    if ((!('batchId' in (value as Record<string, any>)) && !('batch_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['batchId'] === undefined && (value as Record<string, any>)['batch_id'] === undefined)) return false;
    if (!('uploads' in value) || value['uploads'] === undefined) return false;
    return true;
}

export function UploadBatchCreateResponseFromJSON(json: any): UploadBatchCreateResponse {
    return UploadBatchCreateResponseFromJSONTyped(json, false);
}

export function UploadBatchCreateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadBatchCreateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'batchId': json['batch_id'],
        'uploads': ((json['uploads'] as Array<any>).map(UploadSlotFromJSON)),
    };
}

export function UploadBatchCreateResponseToJSON(json: any): UploadBatchCreateResponse {
    return UploadBatchCreateResponseToJSONTyped(json, false);
}

export function UploadBatchCreateResponseToJSONTyped(value?: UploadBatchCreateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'batch_id': value['batchId'],
        'uploads': ((value['uploads'] as Array<any>).map(UploadSlotToJSON)),
    };
}

